import { http } from '@frontend/fetch';

export const fetchUserPresence = (orgId: string) => {
  return http.get(`/user-presence/v1/org-user-presence?orgId=${orgId}`);
};
